/*
 * @Author: your name
 * @Date: 2021-04-16 10:36:58
 * @LastEditTime: 2021-08-19 17:33:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cloud-recruit/src/main.js
 */

import React from 'react';
import ReactDom from 'react-dom';
import Promise from 'promise-polyfill';
// window.prefixUri = '/hrmanage/51hr/api/web'; //测试环境
window.prefixUri = '/51hr/api/web'; //生产环境

window.resumeUrl = '/resumeClient/api'; //请求接口前缀
// css文件
import 'rc-steps/assets/index.css';
import 'static/css/normalize.css';
import 'static/css/nprogress.css';
import './scss/main.scss';

// NProgress configure
NProgress.configure({
    className: 'top56'
})

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

// React 性能分析工具
// import Perf from 'react-addons-perf';
// window.Perf = Perf;

// react-router
import { Router , hashHistory } from 'react-router'

// redux
import { createStore , applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import reducer from './reducer';
// import getRoutes from './router/router.bak';
// const routes = getRoutes();
import routes from './router';
import 'babel-polyfill';

// 创建一个store
const store = createStore(
    reducer,
    applyMiddleware(thunk)
);

ReactDom.render(
    <Provider store={store}>
        <Router history={hashHistory} routes={routes}>
        </Router>
    </Provider>
,document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/main.js